export default __webpack_public_path__ + "static/media/React-Pizza.eaf660f2.jpg";